import { useEffect } from 'react';
import { getShellLoginUrl } from '@/config/shell';

/**
 * Legacy /signin route — navigates to the in-shell Auth MFE (same origin).
 */
export default function SignInPage() {
  useEffect(() => {
    window.location.assign(getShellLoginUrl());
  }, []);

  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center px-4">
      <p className="text-sm text-foreground-500">Redirecting to sign in…</p>
    </main>
  );
}
